// extracted by mini-css-extract-plugin
export default {"rescheduleIconWrap":"Cancelled_rescheduleIconWrap__GTZDU"};